import { render, staticRenderFns } from "./Certificados.vue?vue&type=template&id=3bacb51d&scoped=true"
import script from "./Certificados.vue?vue&type=script&lang=js"
export * from "./Certificados.vue?vue&type=script&lang=js"
import style0 from "./Certificados.vue?vue&type=style&index=0&id=3bacb51d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bacb51d",
  null
  
)

export default component.exports